<ng-template #modal let-hide="close">
  <div class="modal-header">
    <h4 i18n class="modal-title">Welcome to PeerTube, dear administrator!</h4>
    <button class="border-0 p-0" title="Close this modal" i18n-title (click)="hide()">
      <my-global-icon iconName="cross"></my-global-icon>
    </button>
  </div>

  <div class="modal-body">

    <div class="block-documentation">
      <div class="columns">
        <a class="link-block" href="https://docs.joinpeertube.org/maintain/tools" target="_blank" rel="noopener noreferrer">
          <a i18n class="link-title" href="https://docs.joinpeertube.org/maintain/tools" target="_blank" rel="noopener noreferrer">CLI documentation</a>

          <div i18n>Upload or import videos, parse logs, prune storage directories, reset user password...</div>
        </a>

        <a class="link-block" href="https://docs.joinpeertube.org/admin/following-instances" target="_blank" rel="noopener noreferrer">
          <a i18n class="link-title" href="https://docs.joinpeertube.org/admin/following-instances" target="_blank" rel="noopener noreferrer">Administer documentation</a>

          <div i18n>Managing users, following other instances, dealing with spammers...</div>
        </a>

        <a class="link-block" href="https://docs.joinpeertube.org/use/setup-account" target="_blank" rel="noopener noreferrer">
          <a i18n class="link-title" href="https://docs.joinpeertube.org/use/setup-account" target="_blank" rel="noopener noreferrer">Use documentation</a>

          <div i18n>Setup your account, managing video playlists, discover third-party applications...</div>
        </a>
      </div>
    </div>

    <div class="two-columns">

      <img class="mascot mascot-fw" src="/client/assets/images/mascot/pointing.svg" alt="mascot">

      <div class="block-links">
        <div i18n class="subtitle">Useful links</div>

        <ul>
          <li i18n>
            Official PeerTube website (news, support, contribute...): <a href="https://joinpeertube.org" target="_blank" rel="noopener noreferrer">https://joinpeertube.org</a>
          </li>

          <li i18n>
            Put your instance on the public PeerTube index: <a href="https://instances.joinpeertube.org/instances">https://instances.joinpeertube.org/instances</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="two-columns">
      <img class="mascot" src="/client/assets/images/mascot/happy.svg" alt="mascot">

      <div class="block-configuration">
        <div i18n class="subtitle">It's time to configure your instance!</div>

        <p i18n>
          Choosing your <strong>instance name</strong>, <strong>setting up a description</strong>, specifying <strong>who you are</strong>,
          why <strong>you created your instance</strong> and <strong>how long</strong> you plan to <strong>maintain it</strong>
          is very important for visitors to understand on what type of instance they are.
        </p>

        <p i18n>
          If you want to open registrations, please decide what <strong>your moderation rules</strong> and <strong>instance
          terms of service</strong> are, as well as specify the categories and languages and your moderators speak.
          This way, you will help users to register on <strong>the appropriate</strong> PeerTube instance.
        </p>
      </div>
    </div>
  </div>

  <div class="modal-footer inputs">
    <input
      type="button" role="button" i18n-value value="Remind me later" class="peertube-button grey-button"
      (click)="hide()" (key.enter)="hide()"
    >

    <a i18n (click)="doNotOpenAgain(); hide()" (key.enter)="doNotOpenAgain(); hide()"
       class="peertube-button-link orange-button" href="/admin/config/edit-custom" target="_blank"
       rel="noopener noreferrer" ngbAutofocus>
      Configure my instance
    </a>
  </div>

</ng-template>
